import routes from '@/modules/notification/notification-routes';
import store from '@/modules/notification/notification-store';

export default {
  routes,
  store
};
